export type ICalendarResources = typeof CalendarResources;

export const CalendarResources = {
    months: [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień",
    ],
    weekdays: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "Sb"],
};
